import DOMPurify from 'isomorphic-dompurify';
import * as React from 'react';
import { TMessage } from '../../../types/messages';

export const useMessageHtmlText = ({ htmlText }: TMessage) => {
  return React.useMemo(() => {
    const trimmedText = htmlText?.trim();

    return trimmedText ? DOMPurify.sanitize(trimmedText) : null;
  }, [htmlText]);
};
